export default __webpack_public_path__ + "static/media/bursaries@2x.6fe06297.png";